module.exports = __webpack_public_path__ + "b09bad71bfe739a139c9e5af8929e835.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-19.png
// module id = 1769
// module chunks = 0